import { Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { EnvironmentService } from '@core/feature';
import { SdModalService } from '@sdvor/shared/ui/v2';

@Injectable({
  providedIn: 'root',
})
export class CityUiEventHandler {
  constructor(
    private cityService: CityService,
    private modalService: SdModalService,
    private environmentService: EnvironmentService,
  ) {}

  init(): void {
    if (this.environmentService.isPlatformBrowser) {
      this.cityService.openCityListEvent.subscribe(() => {
        import('./v2/cities-dialog').then((index) => {
          this.modalService.open(index.CitiesDialogComponent, {
            modalType: { xs: 'fullscreen', lg: 'standard' },
            maxWidth: { lg: '812px' },
          });
        });
      });
    }
  }
}
